import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  IconButton,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import logo from "../Images/BizBridge-whiteLogo-1.png";
import { LocationOn, PhoneInTalk, Email } from "@mui/icons-material";
import { Facebook, LinkedIn, Twitter, Instagram } from "@mui/icons-material";

const linkStyles = {
  color: "rgba(255, 255, 255, 0.8)",
  textDecoration: "none",
  fontSize: { xs: "0.9rem", md: "1rem" },
  "&:hover": { color: "#2e9e53" },
  transition: "color 0.3s",
};

// --- Social Media Links with Brand Colors ---
const socials = [
  // { icon: <Facebook />, label: "Facebook", href: "#", hoverBg: "#1877F2" },
  // { icon: <Twitter />, label: "Twitter", href: "#", hoverBg: "#1DA1F2" },
  {
    icon: <LinkedIn />,
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/bizbridge-technology-private-limited",
    hoverBg: "#0A66C2",
  },
  {
    icon: <Instagram />,
    label: "Instagram",
    href: "https://www.instagram.com/bizbridge_technology?utm_source=qr&igsh=MXZobjBmbzdoYTA5Yg==",
    hoverBg:
      "linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)",
  },
];

const Footer = () => {
  const navigate = useNavigate();

  // ✅ Same-page anchor scroll handler (no reload)
  const handleAnchorClick = (anchor) => (e) => {
    e.preventDefault();
    const el = document.getElementById(anchor);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      id="contact"
      sx={{ py: { xs: 3, md: 6 }, bgcolor: "#1A1A2E", color: "white" }}
    >
      <Container maxWidth="xl">
        <Grid
          container
          spacing={{ xs: 3, md: 4 }}
          sx={{ mb: { xs: 3, md: 4 } }}
        >
          <Grid item xs={12} sm={6} md={3}>
            <Box
              component="img"
              src={logo}
              alt="BizBridge"
              height={62}
              sx={{ mb: 1 }}
            />
            <Typography
              sx={{
                color: "rgba(255, 255, 255, 0.8)",
                lineHeight: 1.6,
                fontSize: { xs: "0.9rem", md: "1rem" },
                mb: 2,
              }}
            >
              {/* Transforming B2B commerce for India's MSMEs, one dealer at a time. */}
              Precision-Built Technology for Growing Businesses
            </Typography>
            <Stack direction="row" spacing={1}>
              {socials.map((soc) => (
                <IconButton
                  key={soc.label}
                  aria-label={soc.label}
                  href={soc.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: "#b0b8c3",
                    border: "1px solid #334155",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: soc.hoverBg,
                      color: "#fff",
                      borderColor: "transparent",
                    },
                  }}
                >
                  {soc.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>

          {/* Product — same-page anchor links */}
          <Grid item xs={6} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Archivo Black', sans-serif",
                mb: { xs: 1.5, md: 2 },
                color: "#2e9e53",
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Quicklinks
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: 0.8, md: 1 },
              }}
            >
              {["Features", "Pricing", "Demo"].map((item) => (
                <Typography
                  key={item}
                  // component="a"
                  // href={`/${item.toLowerCase()}`}
                   component={Link} //  React Router Link — no reload
                  to={`/`}
                  // onClick={handleAnchorClick(item.toLowerCase())} // smooth scroll, no reload
                  sx={linkStyles}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Company — internal route links */}
          <Grid item xs={6} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Archivo Black', sans-serif",
                mb: { xs: 1.5, md: 2 },
                color: "#2e9e53",
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Company
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: 0.8, md: 1 },
              }}
            >
              {["About", "Contact", "Terms", "Policy"].map((item) => (
                <Typography
                  key={item}
                  component={Link} //  React Router Link — no reload
                  to={`/${item.toLowerCase()}`}
                  sx={linkStyles}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Contact — tel/mailto/external are fine with href */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Archivo Black', sans-serif",
                mb: { xs: 1.5, md: 2 },
                color: "#2e9e53",
                fontSize: { xs: "1rem", md: "1.25rem" },
              }}
            >
              Contact
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: { xs: 1.2, md: 1.5 },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                <LocationOn
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    color: "#2e9e53",
                    flexShrink: 0,
                    mt: "4px",
                  }}
                />
                <Typography sx={linkStyles}>
                  Bhamashah Techno Hub, Sansthanpath, Jhalana Gram, Malviya
                  Nagar, Jaipur - 302017
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneInTalk
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    color: "#2e9e53",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  component="a"
                  href="tel:+918302044892"
                  sx={linkStyles}
                >
                  +91-8005968738
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Email
                  sx={{
                    fontSize: { xs: "0.95rem", md: "1rem" },
                    color: "#2e9e53",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  component="a"
                  href="mailto:bizbridgetechnologypvt@gmail.com"
                  sx={linkStyles}
                >
                  bizbridgetechnologypvt@gmail.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            pt: { xs: 2, md: 3 },
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: { xs: "0.8rem", md: "0.9rem" },
            }}
          >
            &copy; 2026 BizBridge Technology Pvt. Ltd. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
